__turbopack_context__.v({
  "dataContainer": "styles-module-scss-module__Z7BmVW__dataContainer",
  "earnValue": "styles-module-scss-module__Z7BmVW__earnValue",
  "root": "styles-module-scss-module__Z7BmVW__root",
  "rootDarkMode": "styles-module-scss-module__Z7BmVW__rootDarkMode",
  "title": "styles-module-scss-module__Z7BmVW__title",
  "titleDarkMode": "styles-module-scss-module__Z7BmVW__titleDarkMode",
});
